
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-print",
  components: {},
})
export class IconPrint extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconPrint;
